module.exports = __webpack_public_path__ + "static/media/Madfit_Website_08.fc192a87.jpg";